// extracted by mini-css-extract-plugin
export var carouselArrowLeft = "carousel-transformer-module--carousel-arrow-left--dcb9c";
export var carouselArrowRight = "carousel-transformer-module--carousel-arrow-right--9dfeb";
export var carouselImage = "carousel-transformer-module--carousel-image--11479";
export var carouselImageFit = "carousel-transformer-module--carousel-image-fit--55418";
export var carouselTransformer = "carousel-transformer-module--carousel-transformer--c0c12";
export var modalButton = "carousel-transformer-module--modal-button--50743";
export var modalImage = "carousel-transformer-module--modal-image--c7a98";
export var pauseButton = "carousel-transformer-module--pause-button--60134";